import { createAction } from '@reduxjs/toolkit';
import { ListingOptionsActionTypes } from './ListingOptionsActionTypes';
import { IdNameModel } from './ListingOptionsModels';

export const getEventTypesAction = createAction(ListingOptionsActionTypes.GET_EVENT_TYPES);

export const storeEventTypesAction = createAction(
  ListingOptionsActionTypes.STORE_EVENT_TYPES,
  (eventTypes: IdNameModel[]) => {
    return {
      payload: {
        eventTypes,
      },
    };
  },
);

export const getObjectTypesAction = createAction(ListingOptionsActionTypes.GET_OBJECT_TYPES);

export const storeObjectTypesAction = createAction(
  ListingOptionsActionTypes.STORE_OBJECT_TYPES,
  (objectTypes: IdNameModel[]) => {
    return {
      payload: {
        objectTypes,
      },
    };
  },
);

export const getObjectCharacteristicsAction = createAction(
  ListingOptionsActionTypes.GET_OBJECT_CHARACTERISTICS,
);

export const storeObjectCharacteristicsAction = createAction(
  ListingOptionsActionTypes.STORE_OBJECT_CHARACTERISTICS,
  (objectCharacteristics: IdNameModel[]) => {
    return {
      payload: {
        objectCharacteristics,
      },
    };
  },
);

export const getOfferFeaturesAction = createAction(ListingOptionsActionTypes.GET_OFFER_FEATURES);

export const storeOfferFeaturesAction = createAction(
  ListingOptionsActionTypes.STORE_OFFER_FEATURES,
  (offerFeatures: IdNameModel[]) => {
    return {
      payload: {
        offerFeatures,
      },
    };
  },
);
